import axios from "axios";
import { config } from "./global";

export const httpClient = axios.create({
  baseURL: config.apiUrl,
});
